import { render, staticRenderFns } from "./layout-testimonial-card.vue?vue&type=template&id=06c0fe92&scoped=true&"
import script from "./layout-testimonial-card.vue?vue&type=script&lang=js&"
export * from "./layout-testimonial-card.vue?vue&type=script&lang=js&"
import style0 from "./layout-testimonial-card.vue?vue&type=style&index=0&id=06c0fe92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0fe92",
  null
  
)

export default component.exports